import React, { useEffect } from "react";
import { createPortal } from "react-dom";

export default function HostingInfoDialog({ onClose }) {
  useEffect(() => {
    function handleKey(e) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  const dialog = (
    <div
      className="modal-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal" style={{ maxWidth: 560 }} data-testid="hosting-info-dialog">
        <div className="modal-header">
          <h2>⚡ Eigene Domain verbinden</h2>
          <button
            type="button"
            className="icon-btn"
            onClick={onClose}
            title="Schließen"
            aria-label="Schließen"
            data-testid="hosting-info-x"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="modal-body">
          <p style={{ margin: 0, color: "var(--text-soft)", lineHeight: 1.6 }}>
            Diese App läuft aktuell nur auf der <b style={{ color: "var(--gold)" }}>Emergent-Hosting-URL</b>.
            Du kannst jederzeit eine <b style={{ color: "var(--gold)" }}>eigene Domain</b> verbinden — das geht so:
          </p>

          <ol style={{ margin: 0, paddingLeft: 22, color: "var(--text)", lineHeight: 1.7 }}>
            <li>
              <b>App in Emergent öffnen</b> — gehe ins zugehörige Workspace/Projekt.
            </li>
            <li>
              Auf <b>&bdquo;Deployments&ldquo;</b> oder den <b>Deploy-Button</b> klicken (oben rechts).
            </li>
            <li>
              Im Deployment-Dashboard auf <b>&bdquo;Link domain&ldquo;</b> klicken.
            </li>
            <li>
              Wunsch-Domain eintragen, z. B. <code style={codeStyle}>app.deine-domain.de</code>.
            </li>
            <li>
              Emergent zeigt dir den <b>DNS-Eintrag</b> (CNAME oder A-Record).
            </li>
            <li>
              Bei deinem Domain-Anbieter (IONOS, Strato, Cloudflare …) den DNS-Eintrag setzen.
            </li>
            <li>
              <b>5–15 Min warten</b> — SSL-Zertifikat wird automatisch ausgestellt.
            </li>
          </ol>

          <div style={hintBoxStyle}>
            <b style={{ color: "var(--gold)" }}>Tipp:</b>{" "}
            <span style={{ color: "var(--text-soft)" }}>
              Sobald die Domain aktiv ist, hier in URL-Zentrale die URL der Karte aktualisieren —
              das Badge wechselt dann automatisch auf{" "}
              <span style={{ color: "var(--gold)" }}>🌐 EIGENE DOMAIN</span>.
            </span>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-gold"
            onClick={onClose}
            data-testid="hosting-info-close"
          >
            Verstanden
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(dialog, document.body);
}

const codeStyle = {
  background: "rgba(203,163,95,0.12)",
  border: "1px solid rgba(203,163,95,0.3)",
  padding: "1px 6px",
  borderRadius: 4,
  fontFamily: "monospace",
  fontSize: 12.5,
  color: "var(--gold)",
};

const hintBoxStyle = {
  marginTop: 6,
  padding: "10px 12px",
  background: "rgba(203,163,95,0.06)",
  border: "1px solid rgba(203,163,95,0.18)",
  borderRadius: 8,
  fontSize: 13,
  lineHeight: 1.55,
};
